import { render, staticRenderFns } from "./orderSettings.vue?vue&type=template&id=5e5668aa"
import script from "./orderSettings.vue?vue&type=script&lang=js"
export * from "./orderSettings.vue?vue&type=script&lang=js"
import style0 from "./orderSettings.vue?vue&type=style&index=0&id=5e5668aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports